import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import IntlContainer from './IntlContainer';
import * as serviceWorker from './serviceWorker';
require('typeface-roboto');

ReactDOM.render(<IntlContainer />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
